export default "__VITE_ASSET__CzqNQihB__"